import React from 'react'
import './Harsafe_Meet_Counter_Exp.css'
import { FaCheck } from 'react-icons/fa';

const Counter_Exp = () => {
    return (
        <div class="section harsafe-service-section-04 harsafe-service-section-07 section-padding">
            <div class="container">
                {/* <!-- Service Wrap Start --> */}
                <div class="service-wrap">
                    <div class="section-title text-center">
                        <h3 class="sub-title color-3">Harsafe Meet Solution</h3>
                        <h2 class="title">Highly Tailored Chat Application &amp; Support Services. </h2>
                    </div>
                    <div class="service-content-wrap">
                        <div class="row">
                            <div class="col-lg-6">
                                {/* <!-- Experience Wrap Start --> */}
                                <div class="experience-wrap">
                                    <img class="shape-1" src="assets/images/shape/experince-shape2.png" alt="" />
                                    <div class="experience">
                                        <h3 class="number">2+</h3>
                                        <span>Years Experience Working</span>
                                    </div>
                                </div>
                                {/* <!-- Experience Wrap End --> */}
                            </div>
                            <div class="col-lg-6">
                                {/* <!-- Service Content Start --> */}
                                <div class="service-content">
                                    <p class="text">Empower your organization with a robust platform designed to enhance collaboration, communication, and efficiency across all levels.</p>
                                    <div class="service-list">
                                        <ul>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text">Simplify interactions with secure video calls, instant messaging, and file sharing in one platform.</span>
                                            </li>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text"> Foster seamless connections among teams, clients, and partners through real-time communication tools and notifications.</span>
                                            </li>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text">Utilize advanced analytics to monitor engagement, improve workflows, and drive better results in your organization.</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!-- Service Content En --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Service Wrap End --> */}
            </div>
        </div>
    )
}

export default Counter_Exp